import { useAuthContext } from "providers/Auth";
import { BaseInput } from "shared/components/forms/BaseInput";
import { floatParser } from "shared/components/forms/BaseInput/parsers";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { RENT_PMS_SYNCED, RENT_PMS_UNSYNCED } from "../constants";
import { Register } from "shared/hooks";
import { type HandleChange } from "../PMSRentalInfoForm";
import { PmsSyncOption } from "./PmsSyncOption";
import { PMSValue } from "./PmsValue";

const moneyParser = floatParser({ maxDecimals: 2 });

export const UnitRentField = ({
  handleChange,
  values,
  register,
  rentType,
  id,
  label,
  placeholder,
  unitPmsId
}: {
  handleChange: HandleChange;
  values: Record<string, unknown>;
  register: Register;
  rentType: "monthly" | "home" | "site";
  id: string;
  label: string;
  placeholder?: string;
  unitPmsId?: string;
}) => {
  const { permissions, type } = useAuthContext();

  const isSyncedWithPms = Boolean(
    values[`pms_${rentType}_rent_amount_override`]
  );

  const pmsRentValues = values[`pms_${rentType}_rent_amount`];

  const rentField = register(`${rentType}_rent_amount`);

  const isReadOnly =
    !permissions.canChangeRentAmount || Boolean(unitPmsId && isSyncedWithPms);

  const handlePmsSync = (value: boolean) => {
    handleChange(`pms_${rentType}_rent_amount_override`)(value);

    handleChange(`${rentType}_rent_amount`)(
      values[`pms_${rentType}_rent_amount`] || 0
    );
  };

  return (
    <div className="grid grid-cols-2 gap-4 items-center">
      <div className="money-input-2">
        <Tooltip>
          <TooltipTrigger className="w-full text-left">
            <BaseInput
              readOnly={isReadOnly}
              id={id}
              label={label}
              placeholder={
                Boolean(unitPmsId && isSyncedWithPms) ? "-" : placeholder
              }
              className={isReadOnly ? "[&_.bg-white]:!bg-alpha-40" : ""}
              prefix="$"
              parser={moneyParser}
              required
              value={rentField.value ?? null}
              onChange={(val) => rentField.onChange(val)}
              error={rentField.error}
            />
          </TooltipTrigger>

          {unitPmsId ? (
            <TooltipContent className="max-w-[320px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-white">
              <p>
                {values[`pms_${rentType}_rent_amount_override`]
                  ? RENT_PMS_SYNCED
                  : RENT_PMS_UNSYNCED}
              </p>
            </TooltipContent>
          ) : null}
        </Tooltip>
        {unitPmsId && type.isBoomScreen ? (
          <PmsSyncOption
            value={isSyncedWithPms}
            onChange={handlePmsSync}
            name={id}
          />
        ) : null}
      </div>

      <PMSValue value={pmsRentValues ? `$${pmsRentValues}` : ""} />
    </div>
  );
};
